var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',_vm._g(_vm._b({attrs:{"outlined":"","prepend-icon":"","append-icon":"mdi-paperclip","truncate-length":_vm.truncateLength,"background-color":"background_color","hide-details":"auto","show-size":""},on:{"change":function($event){return _vm.$emit('input', $event)}}},'v-file-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }